import React from 'react';
import PropTypes from 'prop-types';
import PolicyItem from "./PolicyItem";

const PolicyList = props => {
    return (
        <div className="policy__list">
            <div>
                {props.policyList.map(pol => {
                    const policy = props.polInPlay.find(p => p[0] === pol.id);
                    const polValue = policy ? policy[1] : pol.default_value;
                    const polDist = policy ? policy[2] : undefined;

                    return (
                        <li key={pol.id}>
                            <PolicyItem policyDetails={pol} onPolicyValueChanged={props.policyValueChanged}
                                        value={polValue.toString()}
                                        dist={polDist}
                                        hasChanged={props.hasChanged}
                                        hasGameStarted={props.hasGameStarted}
                                        gameHasAdvanced={props.gameHasAdvanced}
                            />
                        </li>
                    )
                })}
            </div>
        </div>
    )
};

PolicyList.propTypes = {
    policyList: PropTypes.array.isRequired,
    policyValueChanged: PropTypes.func.isRequired,
    polInPlay: PropTypes.array.isRequired,
    hasChanged: PropTypes.bool,
};

export default PolicyList;
